// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"236":"bb9d2610","453":"72dc9dd9","473":"0c9fc4c0","487":"732b583f","522":"01a82bb8","570":"de90bc93","593":"7f80f637","644":"3803c0f3","737":"4e5f1d02","858":"b20ed960","896":"223eea8e"}[chunkId] + ".css";
};